import React from 'react';
import PropTypes from 'prop-types';

const Logo = ({ fill, width }) => (
  <svg width={width || '90'} viewBox="0 0 195 144" xmlns="http://www.w3.org/2000/svg">
    <g>
      <g transform="translate(0 144) scale(.1 -.1)" fill={fill || 'currentColor'}>
        <path d="m1463 1133c-55-71-141-183-191-250l-90-123-88 125c-55 76-96 124-106 125-10 0-18-3-18-6s39-60 88-127c48-66 90-126 94-133 5-7-30-64-90-145-123-168-118-159-93-159 14 0 47 38 113 130 51 71 96 130 99 130 4 0 49-58 100-130 58-80 101-130 112-130 9 0 17 3 17 6s-45 68-100 144-100 141-100 144c0 6 254 377 327 479 65 89 26 47-74-80z" />
        <path d="m60 725c0-278 1-285 20-285s20 8 22 260l3 259 155-226c153-223 348-494 378-523 8-8-108 168-259 393-227 339-277 407-296 407h-23v-285z" />
        <path d="m540 725v-285h195c167 0 195 2 195 15s-26 15-175 15h-175v125 125l162 2c118 2 162 6 166 16 3 9-34 12-162 12h-166v115 115h175c149 0 175 2 175 15s-28 15-195 15h-195v-285z" />
        <path d="m1430 995c0-12 18-15 100-15h100v-270c0-263 0-270 20-270s20 7 20 270v270h100c82 0 100 3 100 15 0 13-31 15-220 15s-220-2-220-15z" />
      </g>
      <text
        x="121.232615"
        y="121.63736"
        fill={fill || 'currentColor'}
        fontFamily="Arvo, sans-serif"
        fontSize="16"
        stroke="#000"
        strokeWidth="0"
        xmlSpace="preserve">
        Software
      </text>
    </g>
  </svg>
);

Logo.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.jsx